import React from 'react';
import { TrendingUp, TrendingDown } from 'lucide-react';

const StatsCard = ({ title, value, icon: Icon, change, changeType = 'up', color = 'primary' }) => {
  const colorMap = {
    primary: 'var(--color-primary)',
    success: 'var(--color-success)',
    warning: 'var(--color-warning)',
    danger: 'var(--color-danger)',
    info: 'var(--color-info)',
  };

  return (
    <div className="stats-card">
      <div className="stats-header">
        <span className="stats-title">{title}</span>
        <div className="stats-icon" style={{ background: `${colorMap[color]}20`, color: colorMap[color] }}>
          {Icon && <Icon size={24} />}
        </div>
      </div>
      
      <div className="stats-value">
        <span className="value">{value}</span>
        {change && (
          <span className={`stats-change ${changeType}`}>
            {changeType === 'up' ? <TrendingUp size={16} /> : <TrendingDown size={16} />}
            {change}
          </span>
        )}
      </div>
    </div>
  );
};

export default StatsCard;